/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.emoji.add.custom.emoji.label': 'Adicionar seu próprio emoji',
  'fabric.emoji.add.label': 'Adicionar emoji',
  'fabric.emoji.cancel.label': 'Cancelar',
  'fabric.emoji.categories.label': 'Escolha uma categoria de emoji',
  'fabric.emoji.categories.search.results': 'Resultados da pesquisa',
  'fabric.emoji.category.activity': 'Atividade',
  'fabric.emoji.category.all.uploads': 'Todos os carregamentos',
  'fabric.emoji.category.flags': 'Bandeiras',
  'fabric.emoji.category.foods': 'Comidas e bebidas',
  'fabric.emoji.category.frequent': 'Frequentes',
  'fabric.emoji.category.nature': 'Natureza',
  'fabric.emoji.category.objects': 'Objetos',
  'fabric.emoji.category.people': 'Pessoas',
  'fabric.emoji.category.places': 'Viagens e lugares',
  'fabric.emoji.category.productivity': 'Atlassian e produtividade',
  'fabric.emoji.category.symbols': 'Símbolos',
  'fabric.emoji.category.user.uploads': 'Seus carregamentos',
  'fabric.emoji.choose.file.screenReaderDescription':
    'Selecione um arquivo para o emoji. JPG, PNG ou GIF. Tamanho máximo de 1 MB',
  'fabric.emoji.choose.file.title': 'Escolher arquivo',
  'fabric.emoji.delete.description':
    'Todas as instâncias existentes deste emoji serão substituídas por {emojiShortName}',
  'fabric.emoji.delete.label': 'Remover',
  'fabric.emoji.delete.screenreader.tooltip': 'Para excluir um emoji {shortName}, pressione Backspace',
  'fabric.emoji.delete.title': 'Remover emoji',
  'fabric.emoji.delete.tooltip': 'Excluir',
  'fabric.emoji.emojipicker.emoi.roledescription': 'botão de emoji',
  'fabric.emoji.emojipicker.error': 'Erro!',
  'fabric.emoji.error.delete.failed': 'Falha na remoção',
  'fabric.emoji.error.image.too.big': 'A imagem selecionada tem mais de 1 MB',
  'fabric.emoji.error.invalid.image': 'A imagem selecionada é inválida',
  'fabric.emoji.error.upload.failed': 'Falha no carregamento',
  'fabric.emoji.error.upload.timeout': 'O upload atingiu o tempo limite',
  'fabric.emoji.image.requirements': 'JPG, PNG ou GIF. Tamanho máximo: 1 MB.',
  'fabric.emoji.name.ariaLabel': 'Insira um nome para o novo emoji',
  'fabric.emoji.picker': 'Seletor de emoji',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Resultados da pesquisa} other {Emojis}}',
  'fabric.emoji.pickerlist.tabpanel': 'Painel de ações e lista de emojis',
  'fabric.emoji.placeholder': 'por exemplo: olá',
  'fabric.emoji.preview': 'Seu novo emoji ({emoji}) ficou ótimo',
  'fabric.emoji.preview.title': 'Pré-visualizar',
  'fabric.emoji.retry.label': 'Tentar novamente',
  'fabric.emoji.search.label': 'Nome do emoji',
  'fabric.emoji.search.placeholder': 'Pesquisar',
  'fabric.emoji.search.status': 'Visualizando todos os emojis',
  'fabric.emoji.search.status.count': '{count} emojis encontrados',
  'fabric.emoji.select.skin.list.ariaLabel': 'Seletor de tom de pele',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Escolha seu tom de pele; {selectedTone} selecionado',
};
